import BaseApi from "./BaseApi";

export default class UnitsManagement extends BaseApi{
    construct() {}
    
 
    static async search(params) {
        return await UnitsManagement.getAxiosInstance().get(UnitsManagement.getFullApiUrl(),{params: params});
    }

    static async create(params) {
        return await UnitsManagement.getAxiosInstance().post(UnitsManagement.getFullApiUrl(),params);
    }

    static async update(params, id) {
        return await UnitsManagement.getAxiosInstance().put(UnitsManagement.getFullApiUrl() + id,params);
    }

    static async delete(id) {
        return await UnitsManagement.getAxiosInstance().delete(UnitsManagement.getFullApiUrl() + id);
    }
    
    static async list(params) {
        let url = UnitsManagement.getFullApiUrl() + "list";

        return UnitsManagement.getAxiosInstance().get(url,{params: params});
    }
    
    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/units_management/";
    }

    static getFullApiUrl(){
        let domain = location.pathname.split('/')[1]
        return BaseApi.getFullDomainApiUrl() + "api/" + domain + "/admin/units_management/";
    }
}
